<template>
  <teleport to="body">
    <div class="modal fade" tabindex="-1" ref="modalwindow">
      <div :class="['modal-dialog modal-dialog-centered', size ? ('modal-' + size) : '', modalClass]">
        <div class="modal-content">
          <template v-if="!loading">
            <!-- header -->
            <slot name="modal-header">
              <div class="modal-header position-relative">
                <h5 class="modal-title">{{ title }}</h5>
                <button
                    type="button"
                    class="btn-close position-absolute"
                    style="right: 20px"
                    @click="hide"
                />
              </div>
            </slot>

            <!-- body -->
            <div class="modal-body">
              <slot name="modal-body" />
            </div>

            <!-- footer -->
            <div v-if="!hideFooter" class="modal-footer">
              <slot name="modal-footer" />
            </div>
          </template>

          <div class="my-4" v-else>
            <spinner variant="success" />
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
  name: 'BModal',
  emits: ['hidden', 'shown'],
  props: {
    title: { type: String, default: null },
    size: { type: String, default: '' },
    modalClass: { type: String, default: '' },
    hideFooter: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    backgroundSelector: { type: String, default: '#main-content' }
  },

  data() {
    return {
      modal: null,
      lastFocusedElement: null
    };
  },

  mounted() {
    const modalEl = this.$refs.modalwindow;

    modalEl.addEventListener('shown.bs.modal', this._onShown);
    modalEl.addEventListener('hidden.bs.modal', this._onHidden);
    modalEl.addEventListener('hide.bs.modal', this._onHide);
  },

  beforeUnmount() {
    const modalEl = this.$refs.modalwindow;

    modalEl.removeEventListener('shown.bs.modal', this._onShown);
    modalEl.removeEventListener('hidden.bs.modal', this._onHidden);
    modalEl.removeEventListener('hide.bs.modal', this._onHide);
  },

  methods: {
    _onShown() {
      this.$emit('shown');
    },

    _onHide() {
      document.activeElement?.blur();
    },

    _onHidden() {
      this.$emit('hidden');

      const background = document.querySelector(this.backgroundSelector);
      if (background) {
        background.inert = false;
      }

      this.lastFocusedElement?.focus();
    },

    show() {
      if (!this.modal) {
        this.modal = new Modal(this.$refs.modalwindow, {
          backdrop: true,
          focus: false
        });
      }

      // сохраняем текущий фокус
      this.lastFocusedElement = document.activeElement;

      const background = document.querySelector(this.backgroundSelector);
      if (background) {
        background.inert = true;
      }

      this.modal.show();
    },

    hide() {
      this.modal?.hide();
    }
  }
}
</script>

<style>
.modal {
  z-index: 5000 !important;
}

.modal-backdrop {
  z-index: 4990 !important;
}
</style>